/**
 * Utility helper functions
 */

/**
 * Get end date for a given number of months from now
 * @param monthsAhead Number of months to add to current date
 * @returns ISO date string (YYYY-MM-DD)
 */
export const getEndDate = (monthsAhead: number): string => {
  const futureDate = new Date();
  futureDate.setMonth(futureDate.getMonth() + monthsAhead);
  return futureDate.toISOString().split("T")[0];
};

/**
 * Safely parse JSON from string
 * @param jsonString String to parse
 * @param fallback Fallback value if parsing fails
 * @returns Parsed value or fallback
 */
export const safeJsonParse = <T = unknown>(jsonString: string | null, fallback: T): T => {
  if (!jsonString) return fallback;

  try {
    return JSON.parse(jsonString) as T;
  } catch {
    return fallback;
  }
};

/**
 * Calculate available sessions for a ticket
 * @param ticket Ticket object with service_list
 * @returns Number of available sessions
 */
export const calculateAvailableSessions = (ticket: {
  service_list?: Array<{
    count?: string | number;
    count_reserves?: string | number;
  }>;
}): number => {
  if (!ticket.service_list) return 0;

  return ticket.service_list.reduce((total, item) => {
    const count = Number(item.count) || 0;
    const countReserves = Number(item.count_reserves) || 0;
    return total + count + countReserves;
  }, 0);
};
